import { render, staticRenderFns } from "./QuilombolasMaranhao.vue?vue&type=template&id=55aaa524&lang=pug"
import script from "./QuilombolasMaranhao.vue?vue&type=script&lang=js"
export * from "./QuilombolasMaranhao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports